import { NEW_HOST_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const getAllOrganizationMembers = async () => {
  return fetch(`${NEW_HOST_URL}/organization-member/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateOrganizationMember = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization-member/${data?.organizationMemberId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      role: data?.role,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const removeOrganizationMember = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization-member/${data?.organizationMemberId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
